import { render } from "./ReportFileTestReports.vue?vue&type=template&id=2b65ef0d&scoped=true"
import script from "./ReportFileTestReports.vue?vue&type=script&lang=js"
export * from "./ReportFileTestReports.vue?vue&type=script&lang=js"

import "./ReportFileTestReports.vue?vue&type=style&index=0&id=2b65ef0d&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b65ef0d"],['__file',"src/components/reports/ReportFileTestReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b65ef0d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b65ef0d', __exports__)) {
    console.log('reload')
    api.reload('2b65ef0d', __exports__)
  }
  
  module.hot.accept("./ReportFileTestReports.vue?vue&type=template&id=2b65ef0d&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b65ef0d', render)
  })

}


export default __exports__